import { stringifyUrl } from 'query-string';

import { BaseURL, version } from '../base/env';

const getToken = () => {
  const ls = localStorage.getItem(`carfillo`);
  return `token ${JSON.parse(ls)?.Login?.token}`;
};

const getFormHeaders = () => ({
  Accept: 'application/json',
  Authorization: getToken(),
  'app-version': version
});

const getHeaders = () => ({
  Accept: 'application/json',
  Authorization: getToken(),
  'Content-Type': 'application/json',
  'app-version': version
});

const getRequestUrl = (url, query) =>
  stringifyUrl(
    { url, query },
    {
      skipNull: true,
      skipEmptyString: true,
      encode: false
    }
  );

const getFormRequestPayload = (method, body) => ({
  method,
  timeout: 50000,
  headers: getFormHeaders(),
  body: method === 'get' ? null : body
});

const getRequestPayload = (method, body) => ({
  method,
  timeout: 50000,
  headers: getHeaders(),
  body: method === 'get' ? null : JSON.stringify(body)
});

const rawRequest = (method, url, body = {}, query = {}) =>
  new Promise((resolve, reject) => {
    fetch(getRequestUrl(url, query), getRequestPayload(method, body))
      .then((response) => {
        resolve(response);
        return response;
      })
      .catch((error) => {
        reject(error);
      });
  });

const formRequest = (method, url, body = {}, query = {}) =>
  new Promise((resolve, reject) => {
    fetch(getRequestUrl(url, query), getFormRequestPayload(method, body))
      .then((response) => response.json())
      .then((response) => {
        resolve(response);
        return response;
      })
      .catch((error) => {
        reject(error);
      });
  });

const request = (method, url, body = {}, query = {}) =>
  new Promise((resolve, reject) => {
    fetch(getRequestUrl(url, query), getRequestPayload(method, body))
      .then((response) => response.json())
      .then((response) => {
        resolve(response);
        return response;
      })
      .catch((error) => {
        reject(error);
      });
  });

const formGet = (url, query = {}) => formRequest('get', url, null, query);

const formPost = (url, body = {}, query = {}) => formRequest('post', url, body, query);

const formPut = (url, body = {}, query = {}) => formRequest('put', url, body, query);

const formDel = (url, body = {}, query = {}) => formRequest('delete', url, body, query);

const rawGet = (url, query = {}) => rawRequest('get', url, null, query);

const rawPost = (url, body = {}, query = {}) => rawRequest('post', url, body, query);

const rawPut = (url, body = {}, query = {}) => rawRequest('put', url, body, query);

const rawDel = (url, body = {}, query = {}) => rawRequest('delete', url, body, query);

const get = (url, query = {}) => request('get', url, null, query);

const post = (url, body = {}, query = {}) => request('post', url, body, query);

const put = (url, body = {}, query = {}) => request('put', url, body, query);

const del = (url, body = {}, query = {}) => request('delete', url, body, query);

export const Request = {
  get,
  post,
  put,
  del,
  rawGet,
  rawPost,
  rawPut,
  rawDel,
  formGet,
  formPost,
  formPut,
  formDel
};

export const getUrl = (url) => `${BaseURL}${url}`;
